import { useEffect, useState } from "react";
import {
  getRunnerCompetitionDetail,
  RunnerCompetitionDto,
} from "../../../../../../api/runner-competition";
import { PubTournament } from "../../../../../../api/types";
import { calculateTimes } from "../../../../../../utils/timer";

export const useRabbitFestivalCompetition = () => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState<PubTournament[]>([]);
  const [competition, setCompetition] = useState<RunnerCompetitionDto | null>(
    null
  );
  const [competitionId, setCompetitionId] = useState<number>(0);

  const getCompetition = async () => {
    if (!competitionId) return;
    setLoading(true);
    try {
      const res = await getRunnerCompetitionDetail(competitionId);
      setCompetition(res.competition);
      setTournaments(res.events);

      setTimeout(() => {
        setLoading(false);
      }, 50);
    } catch (err) {
      console.error("대회 상세 불러오기 실패:", err);
    }
  };

  const setTournaments = (tournamentList: PubTournament[]) => {
    if (tournamentList.length === 0) return;
    const list = [];
    for (var tournament of tournamentList) {
      if (tournament.timerDto) {
        const time = calculateTimes(
          tournament.timerDto,
          tournament.structure,
          true
        );
        if (time && time.overStack < 1) {
          tournament.timeInfo = time;
          list.push(tournament);
        } else {
          list.push(tournament);
        }
      } else {
        list.push(tournament);
      }
    }
    setEvents(list);
  };

  useEffect(() => {
    getCompetition();
  }, [competitionId]);

  return {
    competition,
    setCompetition,
    competitionId,
    setCompetitionId,
    events,
    loading,
  };
};
